import { StartClient } from "@tanstack/react-start";
import { H } from "highlight.run";
import { StrictMode } from "react";
/// <reference types="vinxi/types/client" />
import { hydrateRoot } from "react-dom/client";
import { env } from "./configs/env";
import { getSessionToken } from "./libs/auth/utils";
import { createRouter } from "./router";

const router = createRouter();

const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
  let [resource, config] = args;

  if (resource.toString().includes("/_server/") && env.FLY_MACHINE_ID) {
    config = {
      ...config,
      headers: {
        ...config?.headers,
        "Fly-Force-Instance-ID": env.FLY_MACHINE_ID,
      },
    };
  }

  return await originalFetch(resource, config);
};

if (import.meta.env.PROD) {
  H.init("7e3yqw6g", {
    serviceName: "frontend-app",
    version: env.RAILWAY_GIT_COMMIT_SHA,
    environment: import.meta.env.MODE,
    tracingOrigins: true,
    networkRecording: {
      enabled: true,
      recordHeadersAndBody: true,
      urlBlocklist: [
        // insert full or partial urls that you don't want to record here
        // Out of the box, Highlight will not record these URLs (they can be safely removed):
        "https://www.googleapis.com/identitytoolkit",
        "https://securetoken.googleapis.com",
      ],
    },
    disableConsoleRecording: true,
  });
}

if (!import.meta.env.SSR) {
  getSessionToken().then((token) => console.log("Session token:", token));
}

hydrateRoot(
  // biome-ignore lint/style/noNonNullAssertion: This is guaranteed to be defined in a browser environment.
  document!,
  <StrictMode>
    <StartClient router={router} />
  </StrictMode>,
);
